'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    width: "1em",
    height: "1em",
    viewBox: "0 0 300 300",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M271 0v152c-.813 74.144-61.167 134-135.5 134C60.665 286 0 225.335 0 150.5l.012 1.5H0V0h271Z",
    id: "documents_svg__a"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    transform: "translate(15)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__namespace.createElement("circle", {
    fill: "#B1C7DD",
    cx: 135.5,
    cy: 150.5,
    r: 135.5
  }), /*#__PURE__*/React__namespace.createElement("mask", {
    id: "documents_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React__namespace.createElement("use", {
    xlinkHref: "#documents_svg__a"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    mask: "url(#documents_svg__b)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M205.866 350a7.833 7.833 0 0 1-1.716-.192L88.683 323.707l1.345-.325 9.797.344 102.915 23.265c.575.13 1.15.191 1.717.191 3.57 0 6.817-2.472 7.636-6.091l3.012-13.32 2.032.073-3.635 16.065c-.819 3.617-4.066 6.091-7.636 6.091m-154.68-34.77-5.357-1.21c-2.923-.66-5.099-2.904-5.829-5.62a7.778 7.778 0 0 0 4.42 2.802l6.75 1.526-.032 1.47c-.008.348.008.693.047 1.032m189.863-93.081-1.112-4.128 1.72-7.603a.07.07 0 0 1 .004-.02l20.738-91.67a7.68 7.68 0 0 0-.074-3.728 7.806 7.806 0 0 1 1.484 6.545l-22.76 100.604",
    fill: "#829DC5"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M255.912 109.01c4.19.949 6.844 5.159 5.896 9.355l-50.246 222.539c-.947 4.196-5.151 6.852-9.342 5.904L44.087 310.99c-4.19-.949-6.843-5.16-5.895-9.356L88.438 79.097c.949-4.197 5.15-6.854 9.341-5.905l158.133 35.818",
    fill: "#DADAD5"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M259.811 118.908c.93-4.205-1.669-8.423-5.773-9.374l-40.307-9.34c-4.104-.95-6.565 1.677-5.471 5.84L235.848 210.9c1.094 4.161 2.75 4.128 3.677-.077l20.286-91.916",
    fill: "#DADAD5"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M238.485 217 237 209c.405 2.182.914 3.27 1.408 3.27.202 0 .402-.182.592-.549l-.515 5.279",
    fill: "#A4ACAF"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M239.696 214c-.65 0-1.317-1.024-1.85-3.077l-2.786-10.753-.006-.159-2.122-8.175L229 172.239v-67.71l.006-.529 5.266 1.319 1.467 79.803L241 209.625l-.525 3.858c-.25.345-.513.517-.779.517",
    fill: "#A4ACAF"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M239.117 218 226 275l23.282-6.166c1.937-.513 3.106-2.439 2.6-4.282L239.117 218",
    fill: "#2E3B6C"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M207.745 97.548 90.695 71 49 255.902l15.897 59.15c.059.214.14.414.232.606L71.046 317l156.043-42.182L240 217.56 207.745 97.548",
    fill: "#DADAD5"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M80.41 327a3.527 3.527 0 0 1-3.388-2.63l-.022-.083 9.723.346 1.946.447-7.35 1.797a3.406 3.406 0 0 1-.908.123m148.638-36.239v-13.395l.169-.759L249.734 271l2.146 10.427c.5 1.89-.611 3.85-2.474 4.357l-20.357 4.977",
    fill: "#829DC5"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "m88.94 324-1.94-.434 3.284.114-1.344.32m139.892-46.264v-.692L229 277l-.168.736",
    fill: "#657DA2"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "m200.866 77-8.916-31.96c-.43-1.543-1.889-2.565-3.47-2.565-.307 0-.62.038-.93.119l-1.107.288-1.052-3.767a7.48 7.48 0 0 0-.391-1.08 34.075 34.075 0 0 1 1.515-.035c4.148 0 6.791.88 7.273 2.945l2.65 9.866 1.961-.494c.31-.08.623-.12.93-.12 1.581 0 3.04 1.023 3.47 2.565L208 76.836l-7.134.164",
    fill: "#829DC5"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#7B8991",
    d: "m233 191-4-14.694V172l4 19"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M246.731 259.734c1.12 4.166-1.364 8.495-5.521 9.617l-156.917 42.38c-4.158 1.123-8.476-1.368-9.597-5.534L15.269 85.267c-1.12-4.166 1.364-8.494 5.522-9.617l156.916-42.38c4.158-1.123 8.478 1.367 9.597 5.533l59.427 220.931",
    fill: "#DADAD5"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M82.605 72c-1.622 0-3.387-.829-4.295-2.121L73 62.326l3.65-1.012c3.392 3.929 5.762 5.785 9.6 5.785 1.665 0 3.608-.35 6.029-1.032C113.535 60.084 186.145 40 186.145 40l.855 3.233L83.724 71.854a4.197 4.197 0 0 1-1.119.146",
    fill: "#A4ACAF"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M83.096 71.447c-1.855.5-4.295-.367-5.42-1.928l-6.49-8.994c-1.126-1.56-3.568-2.428-5.423-1.927L8.518 74.318c-1.856.502-3.943 2.433-3.443 4.293l63.984 237.8c.5 1.86 2.43 2.97 4.285 2.469l176.071-47.54c1.855-.5 2.965-2.433 2.465-4.293L192.293 45.59a3.505 3.505 0 0 0-4.285-2.47L83.096 71.447",
    fill: "#F6BE57"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M50 246 5.12 78.712c-.498-1.852.604-3.774 2.447-4.273L20.265 71c-.976.264-1.827.572-2.57.916L8.537 74.44c-1.843.499-3.915 2.421-3.418 4.273L50 246",
    fill: "#A69752"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M51.471 251 5.075 77.844c-.5-1.865 1.584-3.801 3.438-4.304L17.725 71c-5.587 2.595-5.021 7.264-4.236 11.123 1.105 5.436 22.979 86.551 38.478 141.783l.033 2.04L51.471 251",
    fill: "#EB8D31"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#9E8240",
    d: "m234 197-1-5 1 5M233 199l-1.894-7.46L231 191l1.995 7.848.005.152"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#D0A34C",
    d: "m233 200-2-7.998V192l2 8"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#776835",
    d: "m233 192-4-16 4 16M233 192l-4-15.89V176l3.889 15.428.111.572"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#9E8240",
    d: "m233 192-1.325-5.304L229 176l4 15.998V192"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#EB8D31",
    d: "M231 275v-89l1.151 5.218 1.732 7.835 2.117 74.26-5 1.687"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M228.175 277v-.168l2.825-.778v.189l-2.825.757M55 81.826l.053-3.147L200.748 76l.639 2.363-130.849 3.096h-7.466c-.635 0-1.256.076-1.852.22l-6.22.147",
    fill: "#E39042"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#926431",
    d: "m231 187-2-11 2 11"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#DC6C2B",
    d: "M229 277v-99l2 10.386v87.84l-2 .774"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "m215.348 328-115.57-4.09-5.806-1.323 43.085-10.471L218 316.18 215.348 328m-139.66-9.58-2.179-.498a3.34 3.34 0 0 0 .686-.114l1.24-.336.254.948m-4.1-.934-.82-.188.38-.103c.14.107.287.204.44.29m-6.754-1.54L51 312.792 51.947 268l1.709 6.395.53 33.56 8.558.43 1.858 6.95c.058.215.139.416.233.61",
    fill: "#A4ACAF"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "m69.624 317-5.872-1.34a3.47 3.47 0 0 1-.23-.604l-1.84-6.879 5.32.266 1.76 6.595a3.483 3.483 0 0 0 1.238 1.86l-.376.102M52.69 274.527 51 268.195 51.384 250l.977 3.661.33 20.866",
    fill: "#A4ACAF"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "m69 316-1.722-6.596L69 316m-16.044-61.38L52 250.958 52.514 226l.17 11.014-.26 15.572.532 2.034",
    fill: "#B37330"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M72.52 318a3.554 3.554 0 0 1-2.14-.723 3.456 3.456 0 0 1-1.25-1.847l-1.78-6.549 9.815.486c1.106 4.199 1.835 7.025 1.835 7.025l-5.573 1.488c-.23.062-.459.099-.686.112-.075.004-.147.008-.222.008m-19.97-63.518-.549-2.02.269-15.462.28 17.482",
    fill: "#A6592E"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "m228.926 102-.008-.002V86c.113.518.17 1.055.164 1.606L228.926 102",
    fill: "#829DC5"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#A4ACAF",
    d: "m229.004 102.001-.008-.002.008.002M229.002 102.155l-.006-.002v-.308l.008.002-.002.308"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#7B8991",
    d: "M228.997 105v-1l.006.003-.006.997"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M62 80.11a9.018 9.018 0 0 1 1.987-.22H72l-10 .22",
    fill: "#AA7439"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#A69752",
    d: "m228 317-2-.11.246-26.417L228 290v27"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#7D7A46",
    d: "m226 290 .028-5.075L227 277v12.555l-1 .445"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#5F603B",
    d: "m226 286 .047-9.462L227 276v.778L226 286"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#EB8D31",
    d: "M226 276.243v-.002l1-.484-1 .486"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#9E8240",
    d: "m228 172-1-3.22 1-64.78v68"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#776835",
    d: "m229 176-1-2.795.073-5.205.927 3.354V176"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#724F27",
    d: "m229 176-1-2 1 2M229 176l-1-1.927V174l1 1.922V176"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#9B642E",
    d: "m229 176-1-2 1 2"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#DC6C2B",
    d: "m226 276 .001-.24.999-.76v.258l-1 .742"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#8F4D29",
    d: "m229 176-1-2 1 2"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#D8542B",
    d: "m226 276 .596-103 .404 2.687v99.818l-1 .495"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M52.27 224c-.021-.08-.046-.17-.069-.248L50 81.122 55 81l-.927 55.664L52.27 224",
    fill: "#EB8D31"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "m51.998 225-.033-1c.023.038.049.083.07.122l-.037.878",
    fill: "#E36A2A"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "m55 136 .934-55.852L62 80c-3.359.837-5.922 3.947-5.999 7.626L55 136",
    fill: "#DC6C2B"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M229 87c-.782-3.545-4.085-6.218-8.04-6.218h-12.238L208 77.475 229 77v10",
    fill: "#A69752"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#7D7A46",
    d: "M210 79h-7.123L202 77.101l7.287-.101.713 2"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#EB8D31",
    d: "m203 79-1-2 1 2"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#DC6C2B",
    d: "M203 79H72l130.166-2 .834 2"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#7D7A46",
    d: "m225.727 317-6.727-.333 5.78-25.375L226 291l-.273 26"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#5F603B",
    d: "m219.08 317-2.08-.102 5.775-25.365L225 291l-5.92 26"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#9E8240",
    d: "M217.405 316 137 312.115 223 292l-5.595 24"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#5F603B",
    d: "m225 292 1-5-.043 4.739L225 292"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#474B31",
    d: "m222 292 3.754-14.94.246-.06-.1 8.723-1.443 5.743L222 292"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#776835",
    d: "m136.3 312-35.3-1.736L226 277l-3.307 14.436L136.3 312"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#B27330",
    d: "m101 310 102.827-27.968.016-.005L226 276v.002l-.217.06L101 310"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#9E8240",
    d: "m62 309-9.416-.43L52 275l10 34"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#9E8240",
    d: "m67 309-5.45-.267-9.212-33.785L52 254l15 55"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#AF592E",
    d: "m67 309-15-55 15 55"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M53.182 225 53 223.8l1-87.8-.818 89",
    fill: "#B27330"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "m51.988 236-.176-10.327.037-1.673c.116.378.225.743.339 1.119l-.2 10.881",
    fill: "#AF592E"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "m229 102-14.965-3.427L210 79h11.466c3.707 0 6.8 2.661 7.534 6.19V102",
    fill: "#7D7A46"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "m229 104-13.355-3.561a6.699 6.699 0 0 0-1.206-.211l-.421-.12L214 100l15 4",
    fill: "#9E8240"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "m229 104-15-4c.396.029.811.096 1.243.205L229 103.65v.35",
    fill: "#9E8240"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M214.211 100.05a6.601 6.601 0 0 0-.403-.014l-.02-.087.423.102",
    fill: "#776835"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M228.33 169 214 100c.13 0 .266.005.403.014L229 103.546v.534l-.67 64.92",
    fill: "#776835"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#5F603B",
    d: "m213 100-6.057-1.321L202 81h6.887L213 100"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#776835",
    d: "m212 100-5-1 4.985.936.015.064"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M208.626 106 207 99l4.984 1.394.016.085h-.023c-2.57 0-4.005 2.225-3.351 5.521",
    fill: "#58512D"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "m226.946 173-18.753-67.34c-.803-3.379.96-5.66 4.12-5.66h.028L227 168.06l-.054 4.94",
    fill: "#58512D"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#B27330",
    d: "m204 88-1-7 1 7"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#594825",
    d: "M207 99h-.003L205 88l2 11"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#724F27",
    d: "m228 174-21-75h.004v.001H207L228 174"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "m228 174-21-75 .004.001 2.023 7.213c.024.101.05.203.078.306L228 174M227 173l-18.921-67.694A9.582 9.582 0 0 1 208 105l19 67.899V173",
    fill: "#543F21"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#724F27",
    d: "m228 174-21-75 21 75"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#AF592E",
    d: "m224 157-19-69 3.003 10.905L224 157"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "m100.546 310-23.8-1.183c-2.959-11.33-8.59-32.552-10.099-35.722-1.398-2.937-7.267-22.952-14.647-49.04l1.528-88.831 1.03-48.376c.078-3.68 2.714-6.79 6.167-7.626L70.067 79h132.026L204 86.073v196.069L100.546 310",
    fill: "#A75A2E"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "m77 309-9.462-.486-14.268-54.471-.27-17.505.193-11.538c7.1 25.854 12.746 45.688 14.092 48.6 1.451 3.14 6.869 24.173 9.715 35.4",
    fill: "#A3462C"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#A75A2E",
    d: "m204 283 22-7-.002.178L204 283"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#673D22",
    d: "m228 173-4-16 4 16"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#A3462C",
    d: "M204 283V88l23 86.193-1.055 102.675-21.93 6.126L204 283"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M231 313.139c0 4.323-3.52 7.861-7.822 7.861H60.822C56.52 321 53 317.462 53 313.139V83.86C53 79.538 56.52 76 60.822 76h162.356c4.302 0 7.822 3.538 7.822 7.861V313.14",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#2E3B6C",
    d: "M81 120h123v-8H81zM100 107h86v-8h-86z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#92A2B1",
    d: "M68 139h123v-4H68zM67 147h148v-4H67zM67 156h148v-4H67zM67 163h58v-4H67zM68 178h123v-4H68zM67 185h148v-4H67zM67 194h148v-4H67zM67 202h58v-4H67z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#92A2B1",
    d: "M67 202h148v-4H67zM67 209h58v-4H67z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#92A2B1",
    d: "M67 209h148v-4H67zM67 218h58v-4H67z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#2E3B6C",
    d: "M68 238h40v-4H68zM69 294h50v-2H69zM175.21 247.242c1.81.609 4.77.609 6.578 0 1.81-.613 4.408-.018 5.773 1.316 1.366 1.336 4.034 2.623 5.93 2.862 1.892.236 3.974 1.898 4.625 3.695.654 1.8 2.5 4.115 4.103 5.154 1.606 1.037 2.761 3.44 2.57 5.341-.193 1.904.467 4.795 1.464 6.427.996 1.628.996 4.297 0 5.927-.997 1.632-1.657 4.523-1.464 6.423.191 1.906-.964 4.308-2.57 5.345-1.603 1.035-3.45 3.352-4.103 5.15-.65 1.8-2.733 3.463-4.626 3.7-1.895.236-4.563 1.52-5.929 2.859-1.365 1.336-3.963 1.93-5.773 1.318-1.808-.609-4.768-.609-6.578 0-1.809.611-4.406.018-5.774-1.318-1.363-1.338-4.03-2.623-5.925-2.86-1.895-.236-3.977-1.9-4.63-3.7-.651-1.797-2.497-4.114-4.103-5.15-1.603-1.036-2.759-3.438-2.568-5.344.191-1.9-.466-4.791-1.462-6.423-.997-1.63-.997-4.299 0-5.927.996-1.632 1.653-4.523 1.462-6.427-.19-1.902.965-4.304 2.568-5.34 1.606-1.04 3.452-3.355 4.103-5.155.653-1.797 2.735-3.459 4.63-3.695 1.895-.239 4.562-1.526 5.925-2.862 1.368-1.334 3.965-1.93 5.774-1.316"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M175.673 251.202c1.554.512 4.1.512 5.654 0 1.556-.513 3.788-.015 4.962 1.106 1.175 1.122 3.468 2.2 5.097 2.4 1.629.199 3.419 1.595 3.98 3.103.56 1.508 2.147 3.455 3.526 4.322 1.38.872 2.373 2.89 2.207 4.486-.165 1.598.404 4.022 1.26 5.391.855 1.372.855 3.609 0 4.978-.856 1.37-1.425 3.795-1.26 5.394.166 1.596-.828 3.614-2.207 4.481-1.379.87-2.966 2.818-3.527 4.324-.56 1.51-2.35 2.906-3.979 3.105-1.629.198-3.922 1.279-5.097 2.398-1.174 1.121-3.406 1.622-4.962 1.108-1.554-.512-4.1-.512-5.654 0-1.556.514-3.788.013-4.964-1.108-1.173-1.12-3.466-2.2-5.095-2.398-1.629-.199-3.419-1.595-3.98-3.105-.56-1.506-2.147-3.454-3.524-4.324-1.381-.867-2.375-2.885-2.21-4.481.164-1.599-.403-4.024-1.258-5.394-.856-1.37-.856-3.606 0-4.978.855-1.37 1.422-3.793 1.259-5.391-.166-1.597.828-3.614 2.209-4.486 1.377-.867 2.964-2.814 3.525-4.322.56-1.508 2.35-2.904 3.979-3.102 1.629-.2 3.922-1.28 5.095-2.4 1.176-1.122 3.408-1.62 4.964-1.107",
    fill: "#456CA6"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M178.194 285a10.34 10.34 0 0 1-5.48-1.582c-.69-.431-.92-1.374-.513-2.106.405-.732 1.294-.976 1.984-.544a7.572 7.572 0 0 0 4.01 1.156c4.36 0 7.905-3.762 7.905-8.385 0-.85.65-1.539 1.45-1.539.8 0 1.45.69 1.45 1.54 0 6.318-4.847 11.46-10.806 11.46M187.454 270c-.464 0-.922-.207-1.226-.602a8.387 8.387 0 0 0-6.68-3.292 1.55 1.55 0 0 1-1.548-1.552 1.55 1.55 0 0 1 1.547-1.554c3.597 0 6.925 1.638 9.129 4.496a1.554 1.554 0 0 1-1.222 2.504M168.484 276c-.82 0-1.484-.7-1.484-1.56 0-4.29 2.228-8.217 5.813-10.252.72-.41 1.62-.126 2.008.633.39.759.12 1.706-.6 2.117-2.624 1.488-4.256 4.362-4.256 7.501 0 .861-.662 1.561-1.481 1.561",
    fill: "#385695"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M178.238 292c-4.81 0-9.62-1.705-13.28-5.118-2.377-2.217-4.072-4.981-4.906-7.993-.224-.808.298-1.633 1.165-1.84.864-.21 1.75.277 1.972 1.085.69 2.49 2.094 4.778 4.058 6.613 6.062 5.646 15.925 5.646 21.986-.004.635-.59 1.66-.59 2.293 0 .632.59.632 1.546 0 2.137-3.665 3.413-8.476 5.12-13.288 5.12M194.298 277a1.86 1.86 0 0 1-.201-.013c-.859-.102-1.466-.842-1.356-1.652.594-4.385-.966-8.691-4.282-11.815a1.418 1.418 0 0 1 0-2.088 1.639 1.639 0 0 1 2.217 0c4.006 3.774 5.892 8.978 5.174 14.279-.1.745-.775 1.289-1.552 1.289M166.515 265c-.387 0-.776-.154-1.072-.46a1.606 1.606 0 0 1 .002-2.217c4.576-4.733 11.271-6.477 17.475-4.554.8.249 1.256 1.123 1.016 1.952-.24.828-1.085 1.302-1.888 1.051-5.133-1.592-10.675-.148-14.462 3.768-.295.306-.682.46-1.071.46",
    fill: "#385695"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#2E3B6C",
    d: "M68 247h40v-4H68zM125 238h90v-4h-90z"
  }))));
});
var Documents = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.Documents = Documents;